import { 
    SET_GRADE_PRIMARIA, 
    SET_GRADE_SECUNDARIA,
    SET_GRADE_PRIMARIA_SELECIONADA_ID,
    SET_GRADE_SECUNDARIA_SELECIONADA_ID,
    SET_QTD_ESTOQUE
} from './mutation-types'
import gradeService from '@/services/grade/gradeService';
import produtoService from '@/services/produtos/produtoService';

export default {
    getGrades({ commit }, {idProduto, tipoGrade}) {
        gradeService.getGrades(idProduto, tipoGrade)
            .then(res => {
                if (tipoGrade === 1) {
                    commit(SET_GRADE_PRIMARIA, res.data)
                } else {
                    commit(SET_GRADE_SECUNDARIA, res.data)
                }
            }
            ).catch(error => console.log(error));

    },

    limparGrades({ commit }) {
        commit(SET_GRADE_PRIMARIA, []);
        commit(SET_GRADE_SECUNDARIA, []);
        commit(SET_GRADE_PRIMARIA_SELECIONADA_ID, null);
        commit(SET_GRADE_SECUNDARIA_SELECIONADA_ID, null);
    },

    selecionarGrade({ 
        commit, 
        dispatch, 
        state: { gradePrimariaSelecionadaId, gradeSecundariaSelecionadaId, gradePrimaria, gradeSecundaria },
        rootState: { DetalhesDoProduto: { produto }, PerfilDaLoja: { perfil } } 
    }, { idProduto, idGrade, tipoGrade }) {
        let buscarQtdEstoque = false;
        if (tipoGrade === 1) {
            commit(SET_GRADE_PRIMARIA_SELECIONADA_ID, idGrade);
            buscarQtdEstoque = idGrade && (!gradeSecundaria.length || gradeSecundariaSelecionadaId)
        } else {
            commit(SET_GRADE_SECUNDARIA_SELECIONADA_ID, idGrade);
            buscarQtdEstoque = idGrade && (!gradePrimaria.length || gradePrimariaSelecionadaId)
        }        

        if(buscarQtdEstoque){
            dispatch('fetchQtdEstoque', {
                localDeEstoqueId: perfil?.localDeEstoqueId,
                produtoPrincipalId: produto?.id,
                gradePrimariaId: tipoGrade === 1 ? idGrade : gradePrimariaSelecionadaId,
                gradeSecundariaId: tipoGrade === 2 ? idGrade : gradeSecundariaSelecionadaId
            })
        } else {
            commit(SET_QTD_ESTOQUE, 0)
        }
        
        dispatch('fetchGradesAtivas', {
            idProduto, idGrade, tipoGrade
        })        
        
        dispatch('fetchQtdEstoque', {
            localDeEstoqueId: perfil?.localDeEstoqueId,
            produtoPrincipalId: produto?.id,
            gradePrimariaId: tipoGrade === 1 ? idGrade : gradePrimariaSelecionadaId,
            gradeSecundariaId: tipoGrade === 2 ? idGrade : gradeSecundariaSelecionadaId
        })
    },

    fetchQtdEstoque({ commit }, { localDeEstoqueId, produtoPrincipalId, gradePrimariaId, gradeSecundariaId }) {
        produtoService.fetchQtdEstoque(localDeEstoqueId, produtoPrincipalId, gradePrimariaId, gradeSecundariaId)
        .then(res => {
            commit(SET_QTD_ESTOQUE, res.data?.quantidade)
        })
        .catch(error => {
            commit(SET_QTD_ESTOQUE, 0);
            console.error(error);
        })
    },

    fetchGradesAtivas({ commit }, { idProduto, idGrade, tipoGrade }) {
        gradeService.getGradesAtivas(idProduto, idGrade, tipoGrade)
        .then(res => {
            commit(tipoGrade === 1 ? SET_GRADE_SECUNDARIA : SET_GRADE_PRIMARIA, res.data)
        })
        .catch(error => {
            commit(tipoGrade === 1 ? SET_GRADE_PRIMARIA : SET_GRADE_SECUNDARIA, [])
            console.error(error);            
        })
    }
}
